"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAVORITE = void 0;
const FAVORITE = exports.FAVORITE = 'favorite';
